export default __webpack_public_path__ + "static/media/working.5361ff70.png";